/* eslint-disable jsx-a11y/anchor-is-valid */

import { Dispatch, SetStateAction } from 'react';
import { MapType } from '../CommonTypes';
import useMaps from '../hooks/useMaps';

const MapViewerArea = ({
  id,
  d,
  toolTipPlace,
  toolTipId,
  setCurrentMap,
}: {
  id: string;
  d: string;
  toolTipPlace: string;
  toolTipId: string;
  setCurrentMap: Dispatch<SetStateAction<MapType | null>>;
}) => {
  const [maps] = useMaps();

  const changePicture = () => {
    setCurrentMap(maps[+id]);
  };

  if (!maps || maps.length === 0) return null;

  const map = maps[+id];
  const setDataToolTip = toolTipId
    ? {
        'data-tooltip-id': toolTipId,
        'data-tooltip-picture': map.imageurl,
        'data-tooltip-content': 'dsadsad',
        'data-tooltip-name': map.name,
        'data-tooltip-place': toolTipPlace,
      }
    : {};

  const classNames = ['view-path show'];

  return (
    <a
      id={'AreaView-' + id}
      href=""
      onClick={e => {
        e.preventDefault();
        changePicture();
      }}
      className={'relative block'}
    >
      <path id={id.toString()} className={classNames.join(' ')} d={d} {...setDataToolTip} />
    </a>
  );
};

export default MapViewerArea;
